import { useState, useCallback, useRef } from "react";

export function useContextLoaderHook() {
  const [spinning, setSpinning] = useState<boolean>(true);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const setLoader = useCallback((value: boolean) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (value) {
      setSpinning(true);
    } else {
      timeoutRef.current = setTimeout(() => setSpinning(false), 120);
    }
  }, []);

  return {
    spinning,
    setLoader,
  };
}
